import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { AnnouncementBar } from "../layout/AnnouncementBar";
import { Header } from "../layout/Header";
import { Footer } from "../layout/Footer";

export const formatDetail = (detail) => {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
};

export const authInput =
  "mt-2 w-full border border-brand-sand bg-brand-surface px-4 py-3.5 text-sm text-brand-charcoal outline-none transition-[border-color,box-shadow] duration-300 placeholder:text-brand-stone/50 focus:border-brand-gold focus:shadow-[0_0_0_3px_rgba(176,148,96,0.12)]";
export const authLabel = "text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-charcoal";
export const authPrimaryBtn =
  "inline-flex w-full items-center justify-center gap-2 bg-brand-charcoal py-4 text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-cream transition-colors duration-300 hover:bg-brand-gold disabled:opacity-50";
export const authSecondaryBtn =
  "inline-flex w-full items-center justify-center gap-2 border border-brand-gold/60 bg-brand-cream py-3.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold transition-colors duration-300 hover:border-brand-gold hover:bg-brand-gold hover:text-brand-cream disabled:opacity-50";

const ease = [0.16, 1, 0.3, 1];

// Split-layout shell for auth pages: muse visual on the left, form card right.
export const AuthShell = ({ testId, image, imageAlt, imagePosition = "object-top", quote, caption, children }) => (
  <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal" data-testid={testId}>
    <AnnouncementBar />
    <Header />
    <main className="mx-auto grid max-w-7xl lg:min-h-[calc(100vh-120px)] lg:grid-cols-12">
      <motion.aside
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, ease }}
        className="relative hidden overflow-hidden lg:col-span-6 lg:block"
      >
        <img
          src={image}
          alt={imageAlt}
          className={`absolute inset-0 h-full w-full object-cover ${imagePosition}`}
          data-testid={`${testId}-image`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/45 via-brand-charcoal/5 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-12">
          <p className="font-serif text-3xl font-medium italic leading-snug text-brand-cream drop-shadow-sm">{quote}</p>
          <p className="mt-3 text-[11px] uppercase tracking-[0.25em] text-brand-gold-light">{caption}</p>
        </div>
      </motion.aside>
      <div className="flex items-center justify-center px-5 py-12 sm:px-8 lg:col-span-6 lg:px-16 lg:py-16">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease }}
          className="w-full max-w-md border border-brand-sand bg-brand-surface px-6 py-10 shadow-[0_40px_80px_-40px_rgba(28,25,23,0.3)] sm:px-10"
        >
          <Link to="/" aria-label="HESHAURA home" className="mb-8 flex justify-center">
            <img
              src="/brand/heshaura-logo.png"
              alt="HESHAURA"
              className="h-[34px] w-auto max-w-[220px] object-contain sm:h-[38px]"
              data-testid="auth-logo"
            />
          </Link>
          {children}
        </motion.div>
      </div>
    </main>
    <Footer />
  </div>
);
